import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { useMemo } from 'react';
import { m as merge } from '../../unsorted/index.js';
import { useHover } from '../../hooks/useHover.js';
import { inputResetStyles } from '../../utils/styleHelpers.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { useForwardLocalDomRef } from '../../hooks/useForwardLocalDomRef.js';
import { B as Box } from '../Box/Box.js';
import { I as Icon } from '../Icon/Icon.js';
import { useTheme } from '../../hooks/useTheme.js';

var containerStyles = {
  w: "base.spacing.x5",
  h: "base.spacing.x5",
  pos: "relative"
};
var inputCssStyles = function inputCssStyles(theme) {
  return {
    "&:disabled + .checkContainer": {
      boxShadow: "none"
    },
    "&:checked + .checkContainer": {
      borderWidth: theme.base.border.size[200],
      borderColor: theme.base.color.text.body.primary
    },
    "&:hover:not(:disabled) + .checkContainer": {
      borderColor: theme.base.color.translucent.standard[800],
      boxShadow: theme.base.shadow[300]
    },
    "&:checked:hover:not(:disabled) + .checkContainer": {
      borderColor: theme.base.color.text.body.secondary,
      borderWidth: theme.base.border.size[100]
    },
    "&:checked + .checkContainer > .checkIcon": {
      opacity: "1"
    }
  };
};
var checkContainerSx = {
  borderStyle: "solid",
  borderWidth: "base.border.size.100",
  borderColor: "base.color.translucent.standard.500",
  bg: "base.color.translucent.emphasis.100",
  brad: "base.borderRadius.x2",
  w: "base.spacing.x5",
  h: "base.spacing.x5",
  d: "flex",
  alignItems: "center",
  justifyContent: "center"
};
var tickSx = {
  fill: "base.color.text.body.primary",
  pointerEvents: "none",
  opacity: "0"
};

var _excluded = ["sx", "testId", "name", "id", "children", "domRef", "className", "onChange", "checked", "value", "disabled", "validationStatus", "inputRef", "rc", "textAlign"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Checkbox(_ref) {
  var _theme$components2;
  var _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? "Checkbox" : _ref$testId,
    name = _ref.name,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? name : _ref$id;
    _ref.children;
    var _ref$domRef = _ref.domRef,
    domRef = _ref$domRef === void 0 ? {
      current: null
    } : _ref$domRef,
    className = _ref.className,
    onChange = _ref.onChange,
    checked = _ref.checked,
    value = _ref.value,
    disabled = _ref.disabled;
    _ref.validationStatus;
    var inputRef = _ref.inputRef,
    rc = _ref.rc;
    _ref.textAlign;
    var inputHtmlAttrs = _objectWithoutProperties(_ref, _excluded);
  var localDomRef = useForwardLocalDomRef(domRef);
  var isHovering = useHover(localDomRef);
  var resetStyles = inputResetStyles(disabled);
  var theme = useTheme();
  var mergedContainerSx = useMemo(function () {
    var _theme$components$Che, _theme$components;
    return merge(containerStyles, (_theme$components$Che = (_theme$components = theme.components) === null || _theme$components === void 0 || (_theme$components = _theme$components.Checkbox) === null || _theme$components === void 0 ? void 0 : _theme$components.sxOverride) !== null && _theme$components$Che !== void 0 ? _theme$components$Che : {}, sx);
  }, [sx, (_theme$components2 = theme.components) === null || _theme$components2 === void 0 || (_theme$components2 = _theme$components2.Checkbox) === null || _theme$components2 === void 0 ? void 0 : _theme$components2.sxOverride]);
  return jsxs(Box, {
    rc: rc,
    domRef: localDomRef,
    testId: testId,
    className: "".concat(className !== null && className !== void 0 ? className : "", " Checkbox"),
    sx: mergedContainerSx,
    children: [jsx("input", _objectSpread(_objectSpread({}, inputHtmlAttrs), {}, {
      type: "checkbox",
      "data-testid": "".concat(testId, "__input"),
      ref: inputRef,
      id: id,
      name: name,
      value: value,
      checked: checked,
      onChange: onChange,
      disabled: disabled,
      css: merge(resetStyles, inputCssStyles(theme)),
      className: "actualInput"
    })), jsx(Box, {
      className: "checkContainer",
      sx: checkContainerSx,
      testId: "".concat(testId, "__checkboxContainer"),
      children: jsx(Icon, {
        icon: "Tick",
        className: "checkIcon",
        variant: isHovering && !disabled ? "regular" : "bold",
        sx: tickSx,
        testId: "".concat(testId, "__checkIcon")
      })
    })]
  });
}
Checkbox.displayName = "Checkbox";

export { Checkbox as C };
//# sourceMappingURL=Checkbox.js.map
